import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Lock, LogIn } from "lucide-react";
import { useAuth } from "../../lib/auth";
import { LOGO_URL } from "../../lib/constants";
import { formatErr } from "../../lib/api";

export default function AdminLogin() {
    const { user, login, loading } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    if (!loading && user) return <Navigate to="/admin" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true); setErr("");
        try {
            await login(email, password);
            nav("/admin");
        } catch (ex) {
            setErr(formatErr(ex));
        } finally { setBusy(false); }
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-4 relative overflow-hidden" data-testid="admin-login-page">
            <Helmet><title>Connexion Admin — Défi Ultime</title></Helmet>
            <div className="absolute inset-0 diag-stripes pointer-events-none" />
            <div className="relative w-full max-w-md glass-card p-8">
                <div className="flex flex-col items-center mb-8">
                    <img src={LOGO_URL} alt="logo" className="h-20 w-20 mb-3" />
                    <div className="font-display text-3xl uppercase tracking-widest">Connexion</div>
                    <div className="label-mini mt-1">Panneau administrateur</div>
                </div>
                <form onSubmit={submit} className="grid gap-4">
                    <div>
                        <label className="label-mini block mb-1">Courriel</label>
                        <input data-testid="login-email" required type="email" className="input-field" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div>
                        <label className="label-mini block mb-1">Mot de passe</label>
                        <input data-testid="login-password" required type="password" className="input-field" value={password} onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    {err && <div className="text-rose-400 text-sm" data-testid="login-error">{err}</div>}
                    <button data-testid="login-submit" disabled={busy} type="submit" className="btn-primary justify-center">
                        <LogIn size={16} /> {busy ? "Connexion..." : "Se connecter"}
                    </button>
                    <div className="text-xs text-white/40 text-center mt-2">
                        <Lock size={12} className="inline mr-1" /> Accès restreint
                    </div>
                </form>
            </div>
        </div>
    );
}
